import BUSD_ABI from "../Contracts/BUSD_ABI.json";
import contractABI from "../Contracts/contract_ABI.json";
import tokenABI from "../Contracts/Token_ABI.json";
import ATMTokenABI from "../Contracts/ATMTokenABI.json";

////////////////mainnet//////////////////
const arr = {
  contract: "0xbf9e27E5746FedAB5E04819C3a442bd22Ae3E96f",
  contractABI: contractABI,
  BUSD: "0x55d398326f99059fF775485246999027B3197955",
  BUSD_ABI: BUSD_ABI,
  ATMToken:"0x55d398326f99059fF775485246999027B3197955",
  ATMTokenABI:ATMTokenABI,
};
////////////////mainnet//////////////////
// const arr = {
//   contract: "0x45E42D7F924157382d5a5ed94E508c247Da4EEA1",
//   contractABI: contractABI,
//   BUSD: "0x325a4deFFd64C92CF627Dd72d118f1b8361c5691",
//   BUSD_ABI: BUSD_ABI,
//   ATMToken:"0x325a4deFFd64C92CF627Dd72d118f1b8361c5691",
//   ATMTokenABI:ATMTokenABI,
// };

//testnet
// const arr = {
//   contract: "0x86b7a3f5179B264122F402f72E5375ca8ce6740C",
//   contractABI: contractABI,
//   BUSD: "0x771d76a2F35b8809119cc712cD9010A19164DFad",
//   BUSD_ABI: BUSD_ABI,
//   ATMToken: "0x771d76a2F35b8809119cc712cD9010A19164DFad",
//   ATMTokenABI: ATMTokenABI,
// };

export const ContractDetails = arr;

// Action creators are generated for each case reducer function

export default ContractDetails;
